<div class="modal-content">
	<div class="modal-header">
		<p>{{ 'learning.all' | translate }}</p>

		<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.close()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12 input-group">
					<input
						type="text"
						class="form-control"
						[(ngModel)]="searchTerms"
						[placeholder]="'general.search' | translate"
						aria-label="search"
						aria-describedby="button-search"
						(keydown.enter)="queryLearnings()"
					/>
					<div class="input-group-append">
						<button class="btn btn-outline-primary" type="button" id="button-search" (click)="queryLearnings()">
							<i class="bi bi-search"></i>
						</button>
					</div>
				</div>
			</div>
			<div *ngFor="let month of learningsPerMonth" class="row">
				<p class="col-12 header">{{ month.date | date: 'LLLL y' }}</p>
				<div *ngFor="let learning of month.learnings" class="col-4 learning-container">
					<app-learning-card [learning]="learning" [showExperimentTag]="true"></app-learning-card>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-primary" (click)="activeModal.close()">{{ 'general.close' | translate }}</button>
	</div>
</div>
